import { useState } from 'react';
import { siteConfig } from '@/mocks/site';

export default function HeroSection() {
  const [showDownload, setShowDownload] = useState(false);

  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20dramatic%20warm%20red%20crimson%20and%20deep%20burgundy%20gradients%2C%20soft%20swirling%20smoke%20and%20atmospheric%20lighting%2C%20cinematic%20dark%20mood%20with%20golden%20highlights%2C%20modern%20editorial%20style%2C%20minimalist%20abstract%20art%2C%20no%20text%20no%20watermark%2C%20clean%20sophisticated%20aesthetic&width=1800&height=1200&seq=hero-main-bg&orientation=landscape"
          alt="51吃瓜App - 每日吃瓜黑料爆料追踪"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-20 pb-10">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-8 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full lg:w-[60%]">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-primary-300 text-sm font-medium">实时更新中</span>
            </div>
            <h1 className="font-heading font-black text-4xl md:text-6xl lg:text-7xl text-background-50 leading-tight tracking-tight">
              全网吃瓜
              <br />
              一站直达
              <br />
              极速爆料
            </h1>
            <p className="mt-6 text-base md:text-lg text-background-50/70 leading-relaxed max-w-lg">
              {siteConfig.description}
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mt-8">
              <button
                onClick={() => setShowDownload(true)}
                className="px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                <i className="ri-download-2-line text-lg"></i>
                立即下载51吃瓜App
              </button>
              <a
                href="#trending"
                className="px-8 py-3.5 border border-background-50/30 text-background-50 font-medium text-sm rounded-full hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                <i className="ri-arrow-down-line text-lg"></i>
                查看今日吃瓜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full lg:w-[40%] hidden lg:flex items-center justify-center">
            <div className="relative w-72 h-[500px]">
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent rounded-3xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20entertainment%20news%20app%20interface%20with%20dark%20theme%20and%20warm%20red%20accents%2C%20modern%20mobile%20app%20UI%20design%2C%20floating%20phone%20on%20transparent%20background%2C%20clean%20minimal%20presentation%2C%20sleek%20device%20with%20rounded%20corners%2C%20no%20text%20no%20watermark&width=600&height=1000&seq=hero-phone-mockup&orientation=portrait"
                alt="51吃瓜App界面展示"
                className="w-full h-full object-contain object-bottom"
              />
            </div>
          </div>
        </div>
      </div>

      {showDownload && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
          <div className="relative bg-background-50 rounded-2xl p-8 max-w-md w-full">
            <button
              onClick={() => setShowDownload(false)}
              className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full hover:bg-background-100 cursor-pointer transition-colors"
            >
              <i className="ri-close-line text-foreground-600 text-lg"></i>
            </button>
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-primary-500 rounded-2xl">
                <i className="ri-fire-line text-background-50 text-2xl"></i>
              </div>
              <h3 className="font-heading font-bold text-xl text-foreground-900 mb-2">
                下载51吃瓜App
              </h3>
              <p className="text-foreground-600 text-sm mb-6">
                扫描二维码或在应用商店搜索「51吃瓜」下载
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <a
                  href="#"
                  className="flex-1 flex items-center justify-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-apple-line text-lg"></i>
                  iOS下载
                </a>
                <a
                  href="#"
                  className="flex-1 flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-android-line text-lg"></i>
                  Android下载
                </a>
              </div>
              <p className="mt-4 text-foreground-500 text-xs">
                最新版本 v4.2.1 · 支持iOS 14+ / Android 8+
              </p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}